// Action types
const SAVE_APPOINTMENTS = "spirit/contacts/SAVE_APPOINTMENTS";
const FILTER_APPOINTMENTS = "spirit/contacts/FILTER_APPOINTMENTS";
const SET_ATTENDANCE_MOTIVES = "spirit/contacts/SET_ATTENDANCE_MOTIVES";
const SET_CONTACT_CAMPAIGNS = "spirit/contacts/SET_CONTACT_CAMPAIGNS";
const SET_CONTACT_TYPE = "spirit/contacts/SET_CONTACT_TYPE";

// InitialState
export const initialState = {
  appointments: [],
  allAppointments: [],
  motives: [],
  contactCampaigns: [],
  actualContactType: "",
};

// Reducers
export default (state = initialState, action) => {
  switch (action.type) {
    case SAVE_APPOINTMENTS:
     
      return {
        ...state,
        appointments: action.info,
        allAppointments: action.info,
      };
    case FILTER_APPOINTMENTS:
      return {
        ...state,
        appointments: action.info,
      };
    case SET_ATTENDANCE_MOTIVES:
      return {
        ...state,
        motives: action.info,
      };
    case SET_CONTACT_CAMPAIGNS:
      return {
        ...state,
        contactCampaigns: action.info,
      };
    case SET_CONTACT_TYPE:
      return {
        ...state,
        actualContactType: action.info,
      };
    default:
      return state;
  }
};

// Action Creators
export const saveAppointments = (info) => ({
  type: SAVE_APPOINTMENTS,
  info,
});

export const filterAppointments = (info) => ({
  type: FILTER_APPOINTMENTS,
  info,
});

export const setAttendaceMotives = (info) => ({
  type: SET_ATTENDANCE_MOTIVES,
  info,
});

export const getContactCampaigns = (info) => ({
  type: SET_CONTACT_CAMPAIGNS,
  info,
});

export const setContactDetailsType = (info) => ({
  type: SET_CONTACT_TYPE,
  info,
});
